import institutionAPI from 'services/institutionAPI'
import toast from 'utils/toast'
import { AlertTypeFilter } from 'AlertsOfVulnerability/types'
import { ImpactModule, Pagination } from 'types'

type Params = {
  MODULE: ImpactModule
  filters?: {
    filter?: AlertTypeFilter
    pagination?: Pagination
  }
}

export default async function readAlertsTypesGlobal({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    // url: `/${MODULE.NAME}/filter/alert-types`,
    url: '/alert/filter/cases-types',
    data: filters || {
      filter: {},
      pagination: {
        page: 1,
        limit: 0,
      },
    },
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
